import { motion } from 'motion/react';
import styled from 'styled-components';

const SupportiveDotsWrapper = styled.div`
	display: flex;
	align-items: center;
	padding-top: 5px;
	margin-left: 2px;
`;

const RegularDotsWrapper = styled.div`
	display: flex;
	align-items: center;
	padding: 16px;
`;

const Dot = styled(motion.div)`
	border-radius: 50%;
	margin-right: 2px;
`;

const SupportiveDot = styled(Dot)`
	height: 3px;
	width: 3px;
	background-color: var(--main-text-supportive);
`;

const RegularDot = styled(Dot)`
	height: 12px;
	width: 12px;
	background-color: var(--main-text);
`;

const itemVariants = {
	initial: { scale: 1 },
	animate: { scale: 0.75 }
};
const transition = (i: number) => ({ duration: 0.3, delay: i * 0.3, repeat: Infinity, repeatDelay: 0.6 });
const RegularDots = () => (
	<RegularDotsWrapper>
		{[1, 2, 3].map((i, index) => (
			<RegularDot
				key={i}
				variants={itemVariants}
				initial="initial"
				animate="animate"
				transition={transition(index)}
			/>
		))}
	</RegularDotsWrapper>
);

const SupportiveDots = () => (
	<SupportiveDotsWrapper>
		{[1, 2, 3].map((i, index) => (
			<SupportiveDot
				key={i}
				variants={itemVariants}
				initial="initial"
				animate="animate"
				transition={transition(index)}
			/>
		))}
	</SupportiveDotsWrapper>
);

const AnimatedDots = {
	Supportive: SupportiveDots,
	Regular: RegularDots
};

export default AnimatedDots;
